//constants
import ActionTypes from "../common/constants/ActionTypes";
import EndPoints from "../common/constants/EndPoints";

//data funcitons
import { get_masterdata } from "./services/get_masterdata";
import {
  email_authentication,
  po_service,
  po_master_service,
  diversion_master_service,
  secondary_grn_master_service,
  execPostRequestsDownloadFile,
  execPostRequestsDownloadExcelFile,
  execGetRequestsDownloadFile,
  execGetRequestsDownloadCSVFile,
  execPostRequestsDownloadCSVFile
} from "./services/po_services";

import {
  indent_master_service,
  indent_service,
} from "./services/indent_services";
import { uploadfiletodms, deletefilefromdms } from "./services/dms_services";
import AccountServices from "./services/AccountServices";

//get master data
export async function get_master_data(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return get_masterdata(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMERS,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_WAREHOUSE,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EMPLOYEE,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EMPLOYER,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SUPPLIER,
    ActionTypes.BACKENDCONFIG + EndPoints.PO_NUMBERS,
    // ActionTypes.BACKENDCONFIG + EndPoints.GET_COMMODITY,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CONSIGNMENT_TYPE,
    // ActionTypes.BACKENDCONFIG + EndPoints.GET_INVOICE_CURRENCY,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TRANSPORTER_DETAILS,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENT_DETAILS,
    ActionTypes.BACKENDCONFIG + EndPoints.UOM_MASTER_LIST,
    ActionTypes.BACKENDCONFIG + EndPoints.CURRENCY_LIST_MASTER,
    config
  );
}

// GET PO MASTER DATA
export async function get_po_masterdata(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_master_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PONOS,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMER_POS,
    config
  );
}

// Secondary GRN Master Data
export async function get_secondary_grn_masterdata(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await secondary_grn_master_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PONOS,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_WONOS,
    config
  );
}

// Diversion Master Data
export async function get_diversion_masterdata(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await diversion_master_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PRIMARYGRNS,
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DIVERSIONIDS,
    config
  );
}

//Create PO
export async function create_purchaseorder(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_PO,
    config
  );
}

// UPDATE PO
export async function update_po(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PO,
    config
  );
}

// GET PO By PO_ID
export async function get_po_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PO_BY_POID,
    config
  );
}

export async function get_po_by_id_non_zero_qua(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PO_BY_POID_NON_ZERO_QUA,
    config
  );
}

export async function delete_po_line_item(queryparams) {
  let config = {
    method: "delete",

    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.DELETE_PO_LINE_ITEM,
    config
  );
}

// PO Details
export async function list_po_details(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEARCH_PO,
    config
  );
}

// CREATE JOB
export async function create_job(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_JOB,
    config
  );
}

// GET JOB BY ID
export async function get_job_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_BY_JOBID,
    config
  );
}

// CREATE PRIMARY GRN
export async function create_primary_grn(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_PRIMARY_GRN,
    config
  );
}

// CREATE UNLOADING ADVICE
export async function create_unload_advice(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_UNLOAD_ADVICE,
    config
  );
}

// GET PRIMARY GRN BY ID
export async function get_primary_grn_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PRIMARY_GRN_BY_ID,
    config
  );
}

// UPDATE PRIMARY GRN
export async function update_primary_grn(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PRIMARY_GRN,
    config
  );
}

// GET UNLOAD ADVICE BY ID
export async function get_unload_advice_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_UNLOAD_BY_UNLOADADVICEID,
    config
  );
}

// CREATE DIVERSION
export async function create_diversion(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_DIVERSION,
    config
  );
}

// GET DIVERSION BY ID
export async function get_diversion_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DIVERSION_BY_ID,
    config
  );
}

// UPDATE JOB DIVERSION
export async function update_diversion(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_JOB_DIVERSION,
    config
  );
}

// UPDATE UNLOAD ADVICE
export async function update_unload_advice(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_UNLOADADVICEID,
    config
  );
}

// Create Secondary GRN
export async function create_secondary_grn(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SECONDARY_GRN,
    config
  );
}

// GET SECONDARY GRN BY ID
export async function get_secondary_grn_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SECONDARY_GRN_BY_ID,
    config
  );
}

// UPDATE SECONDARY GRN
export async function update_secondary_grn(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SECONDARY_GRN,
    config
  );
}

// List Jobs
export async function list_job_details(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEARCH_JOB,
    config
  );
}

// JOb Dashboard
export async function get_job_dashboard(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DASHBOARD,
    config
  );
}

// list vehicals by jobid
export async function list_vehicals_job_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_VEHICALS_BY_JOBID,
    config
  );
}

// UPDATE Job
export async function update_job(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_JOB,
    config
  );
}

// GET Job IDS Master Data -- Indent
export async function get_job_ids_masterdata(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await indent_master_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOBS_IDS,
    config
  );
}

// GET Indent Numbers Master Data -- Indent
export async function get_indent_numbers_masterdata(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await indent_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_NUMBERS,
    config
  );
}

// Create Indent
export async function create_indent(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_INDENT,
    config
  );
}

// GET INDENT BY INDENT_NO
export async function get_indent_by_indent_no(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_BY_INDENT_NO,
    config
  );
}

// UPDATE INDENT
export async function update_indent(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_INDENT,
    config
  );
}

// List Indent
export async function list_indent_details(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEARCH_INDENT,
    config
  );
}

// Indent Dashboard
export async function get_indent_dashboard(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_DASHBOARD,
    config
  );
}

// CREATE LOADING ADVICE
export async function create_loading_advice(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_LOADING_ADVICE,
    config
  );
}

// GET LOADING ADVICE BY ID
export async function get_loading_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_LOADING_ADVICE_BY_ID,
    config
  );
}

// UPDATE LOADING ADVICE
export async function update_loading_advice(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_LOADING_ADVICE,
    config
  );
}

// Indent Transport IDs
export async function indent_transport_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.INDENT_TRANSPORT_NUMBERS,
    config
  );
}

// CREATE INDENT TRANSPORTER
export async function create_indent_transporter(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_INDENT_TRANSPORTER,
    config
  );
}

// GET INDNET TRANSPORTER BY ID
export async function get_indent_transporter_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDNET_TRANSPORTER,
    config
  );
}

// UPDATE INDNET TRANSPORTER
export async function update_indnet_transporter(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_INDENT_TARNSPORTER,
    config
  );
}

// CREATE DELIVERY
export async function create_delivery(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_DELIVERY,
    config
  );
}

// GET DELIVERY BY ID
export async function get_delivery_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DELIVERY,
    config
  );
}

// UPDATE DELIVERY
export async function update_delivery(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_DELIVERY,
    config
  );
}

// CREATE GOODS ISSUE
export async function create_goods_issue(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GOODS_ISSUE,
    config
  );
}

// GET GOODS BY ID
export async function get_goods_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_GOODS,
    config
  );
}

// UPDATE GOODS
export async function update_goods(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_GOODS,
    config
  );
}

//GET JOB IDS
export async function get_job_ids(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOBS_IDS,
    config
  );
}

// GET INDENT TRANSPORT DASHBOARD
export async function get_indent_transport_dashboard(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.INDENT_TRANSPORT_DASHBOARD,
    config
  );
}

// GET INDENT VEHICLE DASHBOARD
export async function get_indent_vehicle_dashboard(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.INDENT_VEHICLE_DASHBOARD,
    config
  );
}

// CREATE COMMODITY MASTER
export async function create_commodity_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_COMMODITY_MASTER,
    config
  );
}

// GET BIN LOCATION DETAILS
export async function get_bin_by_location(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BIN_DETAILS,
    config
  );
}

// UPDATE BIN LOCATION
export async function update_bin_location(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_BIN_DETAILS,
    config
  );
}

// CREATE PV CATEGORY MASTER
export async function create_pv_category(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_PV_CATEGORY,
    config
  );
}

// GET PV CATEGORY BY PV ID
export async function get_pv_category_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PV_CATEGORY,
    config
  );
}

// UPDATE PV CATEGORY
export async function update_pv_category(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PV_CATEGORY,
    config
  );
}

// CREATE SAC CODE MASTER
export async function create_sac_code(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SAC_CODE,
    config
  );
}

// GET SAC CODE BY ID
export async function get_sac_code_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SAC_CODE,
    config
  );
}

// UPDATE SAC CODE MASTER
export async function update_sac_code(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SAC_CODE,
    config
  );
}

export async function create_vendor_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_VENDOR_MASTER,
    config
  );
}

export async function get_vendor_service_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_VENDOR_MASTER,
    config
  );
}

export async function update_vendor_service(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_VENDOR_MASTER,
    config
  );
}

export async function create_currency_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CURRENCY,
    config
  );
}

export async function create_wo_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_WO_MASTER,
    config
  );
}

export async function create_po_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_PO_MASTER,
    config
  );
}

export async function create_equipment_check_list_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENTCHECKLIST_MASTER,
    config
  );
}

export async function get_equipmentchecklist_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENTCHECKLIST_MASTER,
    config
  );
}

export async function update_equipmentchecklist_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENTCHECKLIST_MASTER,
    config
  );
}

export async function create_consignment_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNMENT_MASTER,
    config
  );
}

export async function get_consignment_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CONSIGNMENT_MASTER,
    config
  );
}

export async function update_consignment_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CONSIGNMENT_MASTER,
    config
  );
}

export async function create_supplier_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SUPPLIER_MASTER,
    config
  );
}

export async function get_supplier_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SUPPLIER_MASTER,
    config
  );
}

export async function update_supplier_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SUPPLIER_MASTER,
    config
  );
}

export async function create_tools_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_TOOLS_MASTER,
    config
  );
}

export async function get_tools_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TOOLS_MASTER,
    config
  );
}

export async function update_tools_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_TOOLS_MASTER,
    config
  );
}

export async function create_contact_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONTACT_MASTER,
    config
  );
}

export async function get_contact_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CONTACT_MASTER,
    config
  );
}

export async function update_contact_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CONTACT_MASTER,
    config
  );
}

// UPDATE COMMODITY MASTER
export async function update_commodity_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_COMMODITY_MASTER,
    config
  );
}

//GET COMMODITY MASTER BY ID
export async function get_commodity_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_COMMODITY_MASTER,
    config
  );
}

//GET WO MASTER BY ID
export async function get_wo_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_WO_MASTER,
    config
  );
}

// UPDATE WO MASTER
export async function update_wo_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_WO_MASTER,
    config
  );
}

//GET PO MASTER BY ID
export async function get_po_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PO_MASTER,
    config
  );
}

// UPDATE PO MASTER
export async function update_po_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PO_MASTER,
    config
  );
}

//GET PO MASTER BY ID
export async function get_currency_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CURRENCY_MASTER,
    config
  );
}

// UPDATE Currency MASTER
export async function update_currency_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CURRENCY_MASTER,
    config
  );
}

export async function create_user_login(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.USER_LOGIN,
    config
  );
}

//CREATE BIN MASTER
export async function create_bin_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_BIN_MASTER,
    config
  );
}

//GET BIN MASTER
export async function get_bin_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BIN_MASTER,
    config
  );
}

//UPDATE BIN MASTER
export async function update_bin_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_BIN_MASTER,
    config
  );
}

//CREATE EMPLOYEE MASTER
export async function create_employee_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EMPLOYEE_MASTER,
    config
  );
}

//GET EMPLOYEE MASTER
export async function get_employee_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EMPLOYEE_MASTER,
    config
  );
}

//UPDATE EMPLOYEE MASTER
export async function update_employee_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EMPLOYEE_MASTER,
    config
  );
}

//CREATE EMPLOYER MASTER
export async function create_employer_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EMPLOYER_MASTER,
    config
  );
}

//GET EMPLOYER MASTER
export async function get_employer_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EMPLOYER_MASTER,
    config
  );
}

//UPDATE EMPLOYER MASTER
export async function update_employer_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EMPLOYER_MASTER,
    config
  );
}

//CREATE EQUIPMENT MASTER
export async function create_equipment_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENT_MASTER,
    config
  );
}

//GET EQUIPMENT MASTER
export async function get_equipment_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENT_MASTER,
    config
  );
}

//UPDATE EQUIPMENT MASTER
export async function update_equipment_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENT_MASTER,
    config
  );
}

//CREATE SPARE MASTER
export async function create_spare_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SPARE_MASTER,
    config
  );
}

//GET SPARE MASTER
export async function get_spare_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SPARE_MASTER,
    config
  );
}

//UPDATE SPARE MASTER
export async function update_spare_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SPARE_MASTER,
    config
  );
}

//CREATE TRANSPORTER MASTER
export async function create_transporter_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_TRANSPORTER_MASTER,
    config
  );
}

//GET TRANSPORTER MASTER
export async function get_transporter_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TRANSPORTER_MASTER,
    config
  );
}

//UPDATE TRANSPORTER MASTER
export async function update_transporter_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_TRANSPORTER_MASTER,
    config
  );
}

//CREATE TRANSPORTER REPRESENTATIVE MASTER
export async function create_transporter_representative_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.CREATE_TRANSPORTER_REPRESENTATIVE_MASTER,
    config
  );
}

//GET TRANSPORTER REPRESENTATIVE MASTER
export async function get_transporter_representative_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TRANSPORTER_REPRESENTATIVE_MASTER,
    config
  );
}
//UPDATE TRANSPORTER REPRESENTATIVE MASTER
export async function update_transporter_representative_master(
  queryparams,
  postdata
) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.UPDATE_TRANSPORTER_REPRESENTATIVE_MASTER,
    config
  );
}

//CREATE WAREHOUSE MASTER
export async function create_warehouse_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_WAREHOUSE_MASTER,
    config
  );
}

//GET WAREHOUSE MASTER
export async function get_warehouse_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_WAREHOUSE_MASTER,
    config
  );
}

//UPDATE WAREHOUSE MASTER
export async function update_warehouse_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_WAREHOUSE_MASTER,
    config
  );
}

export async function list_consignment_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CONSIGNMENT_LIST_MASTER,
    config
  );
}

export async function list_customer_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_CUSTOMER_MASTER,
    config
  );
}

export async function list_user_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_USER_MASTER,
    config
  );
}

export async function create_user_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_USER_MASTER,
    config
  );
}

export async function get_user_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_USER_MASTER,
    config
  );
}

export async function update_user_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_USER_MASTER,
    config
  );
}

export async function create_customer_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CUSTOMER_MASTER,
    config
  );
}

export async function get_customer_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMER_MASTER,
    config
  );
}

export async function update_customer_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CUSTOMER_MASTER,
    config
  );
}

export async function list_warehouse_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.WAREHOUSE_LIST_MASTER,
    config
  );
}

export async function get_warehouse_code_by_name(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.WAREHOUSE_CODE_BY_NAME,
    config
  );
}

export async function list_warehouse_master_by_email(queryparams, token) {
  let config = {
    headers: {
      token: token,
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.WAREHOUSE_LIST_BY_EMAIL,
    config
  );
}

export async function list_equipment_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.EQUIPMENT_LIST_MASTER,
    config
  );
}

export async function list_transporter_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.TRANSPORTER_LIST_MASTER,
    config
  );
}

export async function list_currency_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CURRENCY_LIST_MASTER,
    config
  );
}

export async function list_pv_category_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PV_CATEGORY_LIST_MASTER,
    config
  );
}

export async function list_supplier_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SUPPLIER_MASTER,
    config
  );
}

export async function list_employee_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_EMPLOYEE_MASTER,
    config
  );
}

export async function list_employer_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_EMPLOYER_MASTER,
    config
  );
}

export async function get_pos(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PO_NUMBERS,
    config
  );
}

export async function list_tools_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_TOOLS_MASTER,
    config
  );
}

export async function list_spare_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SPARE_MASTER,
    config
  );
}

export async function list_sac_code_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SAC_CODE_MASTER,
    config
  );
}

export async function list_po_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_PO_MASTER,
    config
  );
}

export async function list_wo_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_WO_MASTER,
    config
  );
}

export async function list_bin_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_BIN_MASTER,
    config
  );
}

export async function list_commodity_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_COMMODITY_MASTER,
    config
  );
}
export async function list_contact_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_CONTACT_MASTER,
    config
  );
}
export async function list_vendor_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_VENDOR_MASTER,
    config
  );
}

export async function list_transport_representative_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_TRANSPORTER_REPRESNTATIVE_MASTER,
    config
  );
}

// CREATE SAFETY OBSERVATION
export async function create_safety_observation(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SAFETY_OBSERVATION,
    config
  );
}

// UPDATE SAFETY OBSERVATION
export async function update_safety_observation(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SAFETY_OBSERVATION,
    config
  );
}

// GET SAFETY OBSERVATION BY ID
export async function get_safety_observation_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SAFETY_OBSERVATION_BY_ID,
    config
  );
}

// GET JOBS BY CUSTOMER PO NO
export async function get_job_by_po_no(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOBS_BY_PO_NO,
    config
  );
}

// GET ACTIVITY TYPE BY CUSTOMER PO NO
export async function get_activity_type_by_po(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_ACTIVITY_TYPE_BY_PO_NO,
    config
  );
}

// Indent Vehicle Reporting
export async function create_indent_vehicle_reporting(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_INDENT_VEHICLE_REPORTING,
    config
  );
}

export async function get_indent_vehicle_loading(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_VEHICLE_LOADING,
    config
  );
}

// GET LOADING ADVICE BY ID
export async function get_vehicle_reporting_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_VEHICLE_REPORTING,
    config
  );
}

// UPDATE LOADING ADVICE
export async function update_vehicle_reporting(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_INDENT_VEHICLE_REPORTING,
    config
  );
}

export async function create_vehicle_tracking(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_INDENT_VEHICLE_TRACKING,
    config
  );
}

export async function get_vehicle_tracking(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_VEHICLE_TRACKING,
    config
  );
}

export async function update_vehicle_tracking(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.EDIT_INDENT_VEHICLE_TRACKING,
    config
  );
}

//  GET Indent Vehicle Tracking BY ID
export async function get_vehicle_tracking_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_INDENT_VEHICLE_TRACKING,
    config
  );
}

export async function list_safety_observation(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SAFETY_OBSERVATION,
    config
  );
}

export async function get_safety_tools_tackles_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SAFETY_TOOLS_TACKLES_BY_ID,
    config
  );
}

// UPDATE LOADING ADVICE
export async function update_safety_tools_tackles(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SAFETY_TOOLS_TACKLES,
    config
  );
}

export async function create_safety_tools_tackles(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SAFETY_TOOLS_TACKLES,
    config
  );
}

export async function list_tools_tackles(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SAFETY_TOOLS_TACKLES,
    config
  );
}

export async function get_spare_stock_management_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.GET_SAFETY_SPARE_STOCK_MANAGMENT_BY_ID,
    config
  );
}

// UPDATE LOADING ADVICE
export async function update_spare_stock_management(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SAFETY_SPARE_STOCK_MANAGMENT,
    config
  );
}

export async function create_spare_stock_management(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SAFETY_SPARE_STOCK_MANAGMENT,
    config
  );
}

export async function list_spare_stock_management(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SAFETY_SPARE_STOCK_MANAGMENT,
    config
  );
}

export async function get_damage_cliam_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DAMAGE_CLIAM_BY_ID,
    config
  );
}

// UPDATE LOADING ADVICE
export async function update_damage_cliam(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_DAMAGE_CLIAM,
    config
  );
}

export async function create_damage_cliam(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_DAMAGE_CLIAM,
    config
  );
}

export async function list_damage_cliam(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_DAMAGE_CLIAM,
    config
  );
}

// Consignee Master
// Create
export async function create_consignee_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNEE_MASTER,
    config
  );
}
// UPDATE
export async function update_consignee_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNEE_MASTER,
    config
  );
}
//GET
export async function get_consignee_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNEE_MASTER,
    config
  );
}
// LIST
export async function list_consignee_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CONSIGNEE_MASTER_LIST,
    config
  );
}

// Consigner Master
// Create
export async function create_consigner_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNER_MASTER,
    config
  );
}
// UPDATE
export async function update_consigner_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNER_MASTER,
    config
  );
}
//GET
export async function get_consigner_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CONSIGNER_MASTER,
    config
  );
}
// LIST
export async function list_consigner_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CONSIGNER_MASTER_LIST,
    config
  );
}

// Department Master
// Create
export async function create_department_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_DEPARTMENT_MASTER,
    config
  );
}

// UPDATE
export async function update_department_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_DEPARTMENT_MASTER,
    config
  );
}

//GET
export async function get_department_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_DEPARTMENT_MASTER,
    config
  );
}

// List
export async function list_department_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.DEPARTMENT_MASTER_LIST,
    config
  );
}
export async function list_cha_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CHA_MASTER_LIST,
    config
  );
}

export async function list_equipment_checklist_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_EQUIPMENTCHECKLIST_MASTER,
    config
  );
}

// Create
export async function create_fuel_consumption(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENT_FUEL_CONSUMPTION,
    config
  );
}

// UPDATE
export async function update_fuel_consumption(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENT_FUEL_CONSUMPTION,
    config
  );
}

//GET
export async function get_fuel_consumption_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENT_FUEL_CONSUMPTION_BY_ID,
    config
  );
}

// Create
export async function create_preventive_maintence(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENT_PREVENTIVE_MAINTENCE,
    config
  );
}

// UPDATE
export async function update_preventive_maintence(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENT_PREVENTIVE_MAINTENCE,
    config
  );
}

//GET
export async function get_preventive_maintence_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.GET_EQUIPMENT_PREVENTIVE_MAINTENCE_BY_ID,
    config
  );
}

// Create
export async function create_equipment_compliance(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENT_COMPLIANCE,
    config
  );
}

// UPDATE
export async function update_equipment_compliance(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENT_COMPLIANCE,
    config
  );
}

//GET
export async function get_equipment_compliance_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENT_COMPLIANCE_BY_ID,
    config
  );
}

// Create
export async function create_equipment_maintennance(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_EQUIPMENT_MAINTENNANCE,
    config
  );
}

// UPDATE
export async function update_equipment_maintennance(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_EQUIPMENT_MAINTENNANCE,
    config
  );
}

//GET
export async function get_equipment_maintennance_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EQUIPMENT_MAINTENNANCE_BY_ID,
    config
  );
}

export async function create_stock_verification(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PHYSICAL_STOCK_VERIFICATION,
    config
  );
}

export async function get_stock_verification_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PHYSICAL_STOCK_VERIFICATION,
    config
  );
}

export async function update_stock_verification(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PHYSICAL_STOCK_VERIFICATION,
    config
  );
}

export async function list_stock_verification(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PHYSICAL_STOCK_VERIFICATION_SEARCH,
    config
  );
}
export async function list_audit_report(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.AUDIT_REPORT_SEARCH,
    config
  );
}

export async function list_equipment_compliance(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_EQUIPMENT_COMPLIANCE,
    config
  );
}

export async function post_audit_report(postdata = null) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execPostRequestsDownloadExcelFile(
    ActionTypes.BACKENDCONFIG + EndPoints.AUDIT_REPORT_SEARCH,
    "audit_report",
    config,
    postdata
  );
}

// Spare Stock Management -- CREATE
export async function spare_stock_management_create(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPARE_STOCK_MANAGEMENT,
    config
  );
}
// Spare Stock Management -- UPDATE
export async function spare_stock_management_update(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPARE_STOCK_MANAGEMENT,
    config
  );
}
// Spare Stock Management -- GET
export async function spare_stock_management_get(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPARE_STOCK_MANAGEMENT,
    config
  );
}
// Spare Stock Management -- LIST
export async function spare_stock_management_list(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPARE_STOCK_MANAGEMENT_LIST,
    config
  );
}

// Spare Stock Management -- CREATE
export async function safety_employee_create(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SAFETY_EMPLOYEE,
    config
  );
}
// Spare Stock Management -- UPDATE
export async function safety_employee_update(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_SAFETY_EMPLOYEE,
    config
  );
}
// Spare Stock Management -- GET
export async function safety_employee_get(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SAFETY_EMPLOYEE_BY_ID,
    config
  );
}

export async function customer_invoice_create(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_CUSTOMER_INVOICE,
    config
  );
}

export async function customer_invoice_update(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CUSTOMER_INVOICE,
    config
  );
}

export async function customer_invoice_get(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMER_INVOICE_BY_ID,
    config
  );
}

export async function customer_invoice_list(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_CUSTOMER_INVOICE,
    config
  );
}

export async function create_parameter_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_PARAMETER_MASTER,
    config
  );
}

export async function update_parameter_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PARAMETER_MASTER,
    config
  );
}

export async function get_parameter_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PARAMETER_MASTER_BY_ID,
    config
  );
}

export async function list_parameter_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_PARAMETER_MASTER,
    config
  );
}

export async function list_safety_employee(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SAFETY_EMPLOYEE,
    config
  );
}

// GET Bins
export async function get_bins_by_warehouse_code(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BINS,
    config
  );
}

// non zero remaining quantity bins
export async function get_non_zero_bins_by_warehouse_code(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_NON_ZERO_BINS,
    config
  );
}

// Upload ECCI Document
export async function upload_ecci_document(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    // data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.ECCI_DOCUMENT_UPLOAD,
    config
  );
}
export async function upload_sap_grn_document(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    // data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SAP_GRN_DOCUMENT_UPLOAD,
    config
  );
}

// Delivery Challan PDF Generation
export async function delivery_challan_pdf(postdata = null) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await execPostRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DELIVERY_CHALLAN_PDF,
    "deliverychallan.pdf",
    config,
    postdata
  );
}

// Packaging List PDF Generation
export async function packaging_list_pdf(postdata = null) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await execPostRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.PACKAGING_LIST_PDF,
    "packaginglist.pdf",
    config,
    postdata
  );
}

// Unloading Advice PDF Generation
export async function unloading_advice_pdf(postdata = null) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await execPostRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.UNLOADING_ADVICE_PDF,
    "unloadingadvice.pdf",
    config,
    postdata
  );
}

export async function job_completed_pos(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.JOB_COMPLETED_POS,
    config
  );
}

export async function job_secondary_details(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.JOB_SECONDARY_DETAILS,
    config
  );
}

// Upload PO Document
export async function upload_po_document(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    // data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_PO_DOCUMENT,
    config
  );
}

export async function completed_customer_names(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.COMPLETED_CUSTOMERS,
    config
  );
}
export async function completed_activities_by_customer_name(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.COMPLETED_CUSTOMER_ACTIVITIES,
    config
  );
}
export async function get_total_no_of_packages(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TOTAL_NO_OF_PACKAGES,
    config
  );
}

export async function completed_pos_by_customer_name(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.COMPLETED_POS_BY_CUSTOMER_NAME,
    config
  );
}

export async function multiple_job_completed(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.COMPLETED_MULTIPLE_JOBS,
    config
  );
}

export async function file_upload_to_dms(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await uploadfiletodms(
    ActionTypes.BACKENDCONFIG + EndPoints.FILE_UPLOAD_TO_DMS,
    config
  );
}

export async function delete_file_from_dms(queryparams) {
  let config = {
    method: "delete",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await deletefilefromdms(
    ActionTypes.BACKENDCONFIG + EndPoints.FILE_UPLOAD_TO_DMS,
    config
  );
}

export async function delete_safety_employee_line_item(queryparams) {
  let config = {
    method: "delete",

    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.DELETE_SAFETY_EMLOYEE_ITEM,
    config
  );
}

export async function create_bin_calculation(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.BIN_CALCULATION,
    config
  );
}

export async function get_contract_details_by_sap_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CONTRACT_DETAILS,
    config
  );
}

export async function get_work_order_details_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.WORK_ORDER_DETAILS,
    config
  );
}

// sap call

// export async function send_to_sap_call(postdata="") {
//   let config = {
//     method: 'post',
//     data: postdata,
//     headers: {
//       token: sessionStorage.getItem('token'),
//     },
//   };
//   return await po_service(
//     ActionTypes.BACKENDCONFIG + EndPoints.SEND_TO_SAP,
//     config
//   );
// }

export async function send_to_sap_call(postdata, headers) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
      sap_user_name: headers.sap_user_name,
      sap_password: headers.sap_password,
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEND_TO_SAP,
    config
  );
}

export async function get_pos_by_ums(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_POS_BY_UMCS,
    config
  );
}

export async function get_job_details_by_po(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DETAILS_BY_POS,
    config
  );
}

export async function get_total_gross_weight_in_job(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_TOTAL_GROSS_WEIGHT,
    config
  );
}

export async function get_customer_pos_list(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMER_POS,
    config
  );
}

export async function get_secondary_grn_list(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SECONDARY_GRN_NOS,
    config
  );
}

export async function create_material_group_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_MATERIAL_GROUP_MASTER,
    config
  );
}

// UPDATE
export async function update_material_group_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_MATERIAL_GROUP_MASTER,

    config
  );
}

//GET
export async function get_material_group_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_MATERIAL_GROUP_MASTER,
    config
  );
}
export async function update_custom_station_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_CUSTOM_STATION_MASTER,

    config
  );
}

export async function get_custom_station_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOM_STATION_MASTER,
    config
  );
}

// List
export async function list_material_group_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_MATERIAL_GROUP_MASTER,
    config
  );
}

export async function list_custom_station_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_CUSTOM_STATION_MASTER,
    config
  );
}

export async function get_customer_by_sap_customer_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMER_BY_SAP_CUSTOMER_ID,
    config
  );
}

export async function get_bins_by_umc(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BINS_BY_UMCS,
    config
  );
}

export async function get_bins_for_pravesh(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BINS_FOR_PRAVESH,
    config
  );
}

export async function get_all_commodities(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_COMMODITY,
    config
  );
}

export async function get_all_employees(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EMPLOYEE,
    config
  );
}

export async function secondary_grn_sap_details_insert(
  queryparams = "",
  postdata = ""
) {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_SAP_GRN_BULK_INSERT,
    config
  );
}

export async function mis_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PRAVESH_STOCK_REPORT,
    config
  );
}

export async function download_stock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADSTOCKREPORT +
    "?id=" + passed_params.id +
    "&limit=" + passed_params.limit +
    "&offset=" + 0 +
    "&customer_name=" + passed_params.customer_name +
    "&consignee_name=" + passed_params.consignee_name +
    "&supplier_name=" + passed_params.supplier_name +
    "&material_category=" + passed_params.material_category +
    "&umc_no=" + passed_params.umc_no,

    "Stock_Report.xlsx",
    config
  );
}

export async function agrico_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.AGRICOREPORT,
    config
  );
}

export async function download_agrico_stock_report(startdate, enddate) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADAGRICOSTOCKREPORT +
    "?startdate=" +
    startdate +
    "&enddate=" +
    enddate,

    "Agrico_Report.xlsx",
    config
  );
}

export async function smd_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SMDREPORT,
    config
  );
}

export async function download_smd_stock_report(startdate, enddate) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADSMDSTOCKREPORT +
    "?startdate=" +
    startdate +
    "&enddate=" +
    enddate,

    "SMD_Report.xlsx",
    config
  );
}

export async function grn_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };

  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GRNREPORT +
    "?startdate=" + postdata.startdate +
    "&enddate=" + postdata.enddate +
    "&id=" + postdata.id + "&customer_name=" + postdata.customer_name,
    config
  );
}

export async function download_grn_stock_report(
  startdate,
  enddate,
  id,
  warehouse_name,
  customer_name
) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADGRNREPORT +
    "?startdate=" +
    startdate +
    "&enddate=" +
    enddate +
    "&id=" +
    id +
    "&warehouse_name=" +
    warehouse_name + "&customer_name=" + customer_name,

    "GRN_Report.xlsx",
    config
  );
}

export async function vivo_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.VIVORECEIPTREPORT,
    config
  );
}

export async function download_vivo_stock_report(startdate, enddate, id, customer_name) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  let final_url;

  if (startdate !== null && enddate !== null) {
    final_url = "?id=" + id + "&startdate=" + startdate + "&enddate=" + enddate + "&customer_name=" + customer_name;
  } else {
    final_url = "?id=" + id + "&customer_name=" + customer_name;
  }

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOADVIVORECEIPTREPORT + final_url,
    "VIVO_Report.xlsx",
    config
  );
}

export async function get_vivo_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.VIVOREPORT,
    config
  );
}

export async function download_vivo_report(startdate, enddate, id, supplier_name) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  let final_url;

  if (startdate !== null && enddate !== null) {
    final_url = "?id=" + id + "&startdate=" + startdate + "&enddate=" + enddate + "&supplier_name=" + supplier_name;
  } else {
    final_url = "?id=" + id + "&supplier_name=" + supplier_name;
  }

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOADVIVOREPORT + final_url,
    "VIVO_Report.xlsx",
    config
  );
}
export async function package_level_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PACKAGELEVELREPORT,
    config
  );
}

export async function download_package_level_report(warehouse_code, umc_no) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  let final_url;
    final_url = "?warehouse_code=" + warehouse_code ;
    if(umc_no!= null){
      final_url +="&umc_no=" + umc_no;
    }
  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOADPACKAGELEVELREPORT+final_url,
    "PackageLevel_Report.xlsx",
    config
  );
}

export async function vivo_issue_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.VIVOISSUEREPORT,
    config
  );
}

export async function download_vivo_issue_stock_report(startdate, enddate, id) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  let final_url;

  if (startdate !== null && enddate !== null) {
    final_url = "?id=" + id + "&startdate=" + startdate + "&enddate=" + enddate;
  } else {
    final_url = "?id=" + id;
  }

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOADVIVOISSUEREPORT + final_url,

    "VIVO_ISSUE_Report.xlsx",
    config
  );
}

export async function GI_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GIREPORT,
    config
  );
}

export async function download_GI_stock_report(
  startdate,
  enddate,
  id,
  warehouse_name,
  customer_name
) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADGIREPORT +
    "?startdate=" +
    startdate +
    "&enddate=" +
    enddate +
    "&id=" +
    id +
    "&warehouse_name=" +
    warehouse_name + "&customer_name=" + customer_name,

    "GI_Report.xlsx",
    config
  );
}

// TCIL REPORT
export async function TCIL_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.TCILREPORT,
    config
  );
}

export async function download_TCIL_stock_report(startdate, enddate) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADTCILREPORT +
    "?startdate=" +
    startdate +
    "&enddate=" +
    enddate,

    "TCIL_Report.xlsx",
    config
  );
}

// IMS REPORT

export async function IMS_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.IMSREPORT,
    config
  );
}

export async function get_po_details_by_batch_no(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PO_DETAILS_BY_BATCHNO,
    config
  );
}

export async function get_job_details_by_batch_no(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DETAILS_BY_BATCHNO,
    config
  );
}

export async function upload_indent_line_itemes_document(
  queryparams = "",
  postdata = ""
) {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_INDENT_LINE_ITEM_DOCUMENT,
    config
  );
}

export async function material_pick_list_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.MATERIAL_PICK_LIST_REPORT,
    config
  );
}

export async function download_material_pick_list_report(indent_no) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOAD_MATERIAL_PICK_LIST_REPORT +
    "?indent_no=" +
    indent_no,

    "PickListReport.xlsx",
    config
  );
}

export async function get_booking_ids_by_umcs(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BOOKING_IDS_BY_UMC,
    config
  );
}

export async function get_job_details_by_booking_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DETAILS_BY_BOOKIND_ID,
    config
  );
}

export async function get_booking_ids_by_umcs_primary_grn(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BOOKING_IDS_BY_UMC_PRIMARY_GRN,
    config
  );
}

export async function get_job_details_by_booking_id_primary_grn(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.GET_JOB_DETAILS_BY_BOOKIND_ID_PRIMARY_GRN,
    config
  );
}

export async function get_booking_ids_by_umcs_unload(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BOOKING_IDS_BY_UMC_UNLOAD,
    config
  );
}

export async function get_job_details_by_booking_id_unload(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DETAILS_BY_BOOKIND_ID_UNLOAD,
    config
  );
}

export async function get_job_details_by_booking_id_indent(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT,
    config
  );
}

export async function get_booking_ids_by_umcs_indent_loading(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BOOKING_IDS_BY_UMC_INDENT_LOADING,
    config
  );
}

export async function get_job_details_by_booking_id_indent_loading(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG +
    EndPoints.GET_JOB_DETAILS_BY_BOOKIND_ID_INDENT_LOADING,
    config
  );
}

export async function create_job_custom_details(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_JOB_CUSTOM_DETAILS,
    config
  );
}

// UPDATE
export async function update_job_custom_details(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_JOB_CUSTOM_DETAILS,
    config
  );
}

//GET
export async function get_job_custom_details(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_JOB_CUSTOM_DETAILS,
    config
  );
}

export async function authentication_email(queryparams) {
  let config = {
    params: queryparams,
  };
  return await email_authentication(
    ActionTypes.BACKENDCONFIG + EndPoints.AUTHENTICATION_BY_EMAIL,
    config
  );
}

// get bond nums based on wh code, customer_name, activity_type
export async function get_bond_numbers(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.BOND_NUMBERS,
    config
  );
}

// form a
export async function form_a_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(ActionTypes.BACKENDCONFIG + EndPoints.FORMA, config);
}

// form b
export async function form_b_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(ActionTypes.BACKENDCONFIG + EndPoints.FORMB, config);
}

// upload excel into warehouse -- data from CHAIL
export async function upload_excel_data_from_chail(postdata, reqheaders1) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
      user_email: reqheaders1.user_email,
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOADEXCELFROMCHAIL,
    config
  );
}

// get_all_umc based on warehouse code
export async function get_all_umc(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_ALL_UMC,
    config
  );
}

// download_form_a_pdf
export async function download_form_a_pdf(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    responseType: "blob",
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.FORM_A_PDF,
    config
  );
}

export async function download_form_b_pdf(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    responseType: "blob",
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.FORM_B_PDF,
    config
  );
}

// get_all_bin_locations_based_on_selected_umc
export async function get_all_bin_locations_based_on_selected_umc(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_ALL_BINS_BASED_ON_UMC,
    config
  );
}

// get_custom_station_master
export async function get_custom_station_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOM_STATIONS,
    config
  );
}

// get_bonded_stock_report
export async function get_bonded_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_BONDED_STOCK_REPORT,
    config
  );
}

// download_bonded_stock_report
export async function download_bonded_stock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADBONDEDSTOCKREPORT +
    "?startdate=" + null +
    "&enddate=" + null +
    "&id=" + passed_params.id +
    "&limit=" + passed_params.limit +
    "&offset=" + 0 +
    "&search_key=" + passed_params.search_key,

    "Stock_Report.xlsx",
    config
  );
}

// space certificate
export async function download_space_sertificate(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    // responseType: 'blob'
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPACE_CERTIFICATE,
    config
  );
}

export async function list_space_certificates(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_SPACE_CERTIFICATES,
    config
  );
}

export async function download_space_sertificate_new(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    responseType: "blob",
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SPACE_CERTIFICATE_GENERATE,
    config
  );
}

// job_creation_details
export async function job_creation_details(postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.JOB_CREATION_DETAILS,
    config
  );
}

// update_indent_umc_details
export async function update_indent_umc_details(postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.INDENT_UMC_UPDATE,
    config
  );
}

export async function get_indent_for_loading_otherthan_pravesh(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INDENT_FOR_LOADING,
    config
  );
}

export async function get_ims_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_IMS_STOCK_REPORT,
    config
  );
}
export async function get_rm_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_RM_STOCK_REPORT,
    config
  );
}
export async function get_exwh_stock_report(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EXWH_STOCK_REPORT,
    config
  );
}

export async function get_exwh_stocks_reports_boe(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_EXWH_STOCKS_REPORTS_BOE,
    config
  );
}

// export async function download_IMS_stock_report(startdate, enddate, id) {
//   let config = {
//     token: sessionStorage.getItem("token"),
//   };

//   return await execGetRequestsDownloadFile(
//     ActionTypes.BACKENDCONFIG +
//     EndPoints.DOWNLOADSTOCKREPORT +
//     "?startdate=" +
//     startdate +
//     "&enddate=" +
//     enddate +
//     "&id=" +
//     id,

//     "Stock_Report.xlsx",
//     config
//   );
// }

export async function download_exwhstock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADEXWHSTOCKREPORT +
    "?startdate=" + null +
    "&enddate=" + null +
    "&id=" + passed_params.id +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0 +
    "&search_key=" + passed_params.search_key,

    "Stock_Report.xlsx",
    config
  );
}
export async function download_mmstock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADMMSTOCKREPORT +
    "?startdate=" + null +
    "&enddate=" + null +
    "&id=" + passed_params.id +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0 +
    "&search_key=" + passed_params.search_key,

    "Stock_Report.xlsx",
    config
  );
}

export async function download_imsstock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADIMSTOCKREPORT +
    "?startdate=" + null +
    "&enddate=" + null +
    "&id=" + passed_params.id +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0 +
    "&search_key=" + passed_params.search_key,

    "Stock_Report.xlsx",
    config
  );
}
export async function download_boestock_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };

  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG +
    EndPoints.DOWNLOADBOETOCKREPORT +
    "?startdate=" + null +
    "&enddate=" + null +
    "&id=" + passed_params.id +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0,

    "Stock_Report.xlsx",
    config,
  );
}

// Bulk PO List
export async function list_po_details_bulk(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEARCH_PO_BULK,
    config
  );
}

export async function upload_unload_bin_umc_data(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_UNLOAD_UMC_DATA,
    config
  );
}

export async function upload_unload_bin_umc_data_formdata(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_UNLOAD_UMC_DATA_FORMDATA,
    config
  );
}


export async function upload_unload_bin_umc_pkg_data_formdata(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_UNLOAD_UMC_PKG_DATA_FORMDATA,
    config
  );
}

export async function upload_unload_bin_pl_formdata(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_UNLOAD_BIN_PKG_DATA_FORMDATA,
    config
  );
}

export async function download_delivery_challan_pdf(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    responseType: "blob",
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GENERATE_DELIVERY_CHALLAN,
    config
  );
}

export async function post_sap_grn(postdata = null) {

  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execPostRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.SAP_GRN_DLOAD,
    "sap_grn_bulk_upload",
    config,
    postdata
  );
}


export async function download_unload_template_for_stock_upload(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.UNLOAD_TEMPLATE,
    "stock_upload_unload_template",
    config,
    postdata
  );
}

export async function download_unload_template_for_stock_pkg_upload(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.UNLOAD_PKG_TEMPLATE,
    "stock_upload_unload_template",
    config,
    postdata
  );
}

export async function download_unload_pl(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOAD_PL_UNLOAD,
    "packing_list_upload_template",
    config,
    postdata
  );
}

// Delete PO
export async function delete_purchase_order(queryparams) {
  let config = {
    method: "delete",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.DELETE_PO,
    config
  );
}

// Cancel Job
export async function cancel_job(postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CANCEL_JOB,
    config
  );
}


// SAP Pending reason master
export async function sap_pending_reason_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SAP_PENDING_REASON_MASTER,
    config
  );
}

export async function sap_pending_reason_master_get_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SAP_PENDING_REASON_MASTER,
    config
  );
}

// Sap Pending Reason List
export async function sap_pending_reasons_list(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SEARCH_SAP_PENDING_REASON_MASTER,
    config
  );
}

// Dashboard Data
export async function get_dashboad_data(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DASHBOARD_DATA,
    config
  );
}

export async function get_inventory_inbound_data(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_INVENTORY_DASHBOARD_DATA,
    config
  );
}

export async function get_pending_grn_data(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PENDING_GRN_DATA,
    config
  );
}

export async function out_bound_dashboard_response(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.OUTBOUND_DASHBOARD_DATA,
    config
  );
}

export async function get_age_wise_stock_report(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.AGE_WISE_STOCK_REPORT,
    config
  );
}
export async function grn_complaince_dashboard_response(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GRN_COMPLAINCE_DATA,
    config
  );
}
export async function vivo_complaince_dashboard_response(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.VIVO_COMPLAINCE_DATA,
    config
  );
}
export async function mr_complaince_dashboard_response(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.MR_COMPLAINCE_DATA,
    config
  );
}

export async function get_diversion_report(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DIVERSION_REPORT,
    config
  );
}

export async function get_sap_pending_report(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SAP_PENDING_REPORT,
    config
  );
}

export async function download_sap_pending_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOAD_SAP_PENDING_REPORT +
    "?startdate=" + passed_params.startdate +
    "&enddate=" + passed_params.enddate +
    "&warehouse_code=" + passed_params.warehouse_code +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0,

    "SAP_Pending.xlsx",
    config
  );
}

export async function download_diversion_report(passed_params) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOAD_DIVERSION_REPORT +
    "?startdate=" + passed_params.startdate +
    "&enddate=" + passed_params.enddate +
    "&warehouse_code=" + passed_params.warehouse_code +
    "&customer_name=" + passed_params.customer_name +
    "&limit=" + passed_params.limit +
    "&offset=" + 0,

    "Diversion_Report.xlsx",
    config
  );
}

// receipt type master
export async function list_receipt_type_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.RECEIPT_TYPE_MASTER,
    config
  );
}

export async function create_receipt_type_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_RECEIPT_TYPE_MASTER,
    config
  );
}

export async function get_receipt_type_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_RECEIPT_TYPE_MASTER_ID,
    config
  );
}

// exwh stock bulk upload based on boe
// export async function download_po_template_for_job_exwh(postdata) {
//   let config = {
//     token: sessionStorage.getItem("token"),
//   };
//   return await execGetRequestsDownloadCSVFile(
//     ActionTypes.BACKENDCONFIG + EndPoints.PO_TEMPLATE_TO_CREATE_JOB_EXWH,
//     "po_data_to_create_multliple_jobs",
//     config,
//     postdata
//   );
// }


export async function get_response_based_on_umc_mr_no(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_DATA_FOR_PRAVESH_LOADING_UMC_MR_NUM,
    config
  );
}

export async function get_grn_non_done_indent_numbers(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GRN_NOT_DONE_INDENT_NOS,
    config
  );
}


export async function post_indent_nos_sap_grn_not_done(postdata = null) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.GRN_NOT_DONE_INDENT_STOCK_REGULARIZATION,
    "grn_not_done_indent_stock_regularization",
    config,
    postdata
  );
}

export async function upload_stock_regulation_document(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.SAP_INDENT_STOCK_REGULARIZATION_UPLOAD,
    config
  );
}

export async function get_job_data_based_on_date_range(postdata = null) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.JOB_DATA_BASED_ON_DATE_RANGE,
    "job_details_data",
    config,
    postdata
  )
}

export async function get_settings(queryparams) {
  let config = {
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_SETTINGS,
    config
  );
}

export async function get_purchase_order_data_umc_wh(postdata = null) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.PO_DATA_UMC_WH,
    "purchase_order_details_data",
    config,
    postdata
  )
}

export async function get_indent_data_based_on_date_range(postdata = null) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.INDENT_DATE_BASED_ON_WH,
    "outbound_indent_details_data",
    config,
    postdata
  )
}

export async function loading_advice_umc_details(postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LOADING_ADVICE_UMC_DETAILS,
    config
  );
}

export async function get_all_customers(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_CUSTOMERS,
    config
  );
}

export async function list_vehicle_type_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.LIST_VEHICLE_TYPE_MASTER,
    config
  );
}

export async function create_vehicle_type_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_VEHICLE_TYPE_MASTER,
    config
  );
}

export async function get_vehicle_type_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_VEHICLE_TYPE_BY_ID,
    config
  );
}

export async function po_masternames(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PO_MASTERNAMES,
    config
  );
}


export async function create_job_bulk(postdata) {

  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_JOB_BULK,
    config
  );
}

export async function create_primary_grn_bulk(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.POST_CREATE_PRIMARY_GRN_BULK,
    config
  );
}

export async function list_vehicals_job_id_bulk(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_VEHICALS_BY_JOBID_BULK,
    config
  );
}

// Create Secondary GRN Bulk
export async function create_secondary_grn_bulk(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_SECONDARY_GRN_BULK,
    config
  );
}

//Job Creation Details Validation 
export async function job_creation_details_validation(postdata) {
  console.log('postdata', postdata);
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.JOB_CREATION_DETAILS_VALIDATION,
    config
  );
}

export async function download_pending_grn_data_dashboard(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.PENDING_GRN_DASHBOARD_EXCEL_DOWNLOAD,
    "Pending GRN Graph Data - Dashboard",
    config,
    postdata
  );
}

export async function list_uom_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UOM_MASTER_LIST,
    config
  );
}

// UOM Master
// Create
export async function create_uom_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_UOM_MASTER,
    config
  );
}

//package master
export async function list_package_master(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.PACKAGE_LIST_MASTER,
    config
  );
}
//create_package_master
export async function create_package_master(postdata) {
  let config = {
    method: "post",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.CREATE_PACKAGE,
    config
  );
}

// UPDATE PACKAGE MASTER
export async function update_package_master(queryparams, postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPDATE_PACKAGE_MASTER,
    config
  );
}

//GET PACKAGE MASTER BY ID
export async function get_package_master_by_id(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_PACKAGE_MASTER,
    config
  );
}

// Release Vehicle
export async function vehicle_release(postdata) {
  let config = {
    method: "put",
    data: postdata,
    headers: {
      token: sessionStorage.getItem("token"),
    }
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.RELEASE_VEHICLE,
    config
  );
}

export async function userLogout(postedData) {
  return await AccountServices.userLogoutDetails(
    ActionTypes.BACKENDCONFIG + EndPoints.LOGOUT,
    postedData,
    {
      token: sessionStorage.getItem("token")
    }
  );
}


export async function resetLogin(
  postedData,
) {
  return await AccountServices.resetLogin(
    ActionTypes.BACKENDCONFIG + EndPoints.RESET_TOKEN,
    postedData,
    {
      token: sessionStorage.getItem("token")
    }
  );
}

export async function upload_packing_list_for_unload_umc(queryparams = "", postdata = "") {
  let config = {
    method: "post",
    headers: {
      token: sessionStorage.getItem("token"),
    },
    data: postdata,
    "content-type": "multipart/form-data",
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.UPLOAD_UNLOAD_PACKING_LIST_UMC_DATA,
    config
  );
}

// get_all_umc based on warehouse code
export async function get_all_pos_bonded_stock_verif(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_ALL_POS_STOCK_VERIFICATION,
    config
  );
}

export async function get_all_boe_bonded_stock_verif(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.GET_ALL_BOE_STOCK_VERIFICATION,
    config
  );
}

export async function download_pending_outbound_data_dashboard(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.PENDING_OUTBOUND_DASHBOARD_EXCEL_DOWNLOAD,
    "Pending Outbound Graph Data - Dashboard",
    config,
    postdata
  );
}

export async function get_age_wise_stock_quantity(queryparams) {
  let config = {
    headers: {
      token: sessionStorage.getItem("token"),
    },
    params: queryparams,
  };
  return await po_service(
    ActionTypes.BACKENDCONFIG + EndPoints.AGE_WISE_STOCK_QUANTITY,
    config
  );
}

export async function download_age_stock_qua_data_dashboard(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execGetRequestsDownloadCSVFile(
    ActionTypes.BACKENDCONFIG + EndPoints.STOCK_QUANTITY_AGE_REPORT_DOWNLOAD,
    "Age Wise Stock Quantity Data - Dashboard",
    config,
    postdata
  );
}


export async function download_umc_sticker_packages(postdata) {
  let config = {
    token: sessionStorage.getItem("token"),
  };
  return await execPostRequestsDownloadFile(
    ActionTypes.BACKENDCONFIG + EndPoints.DOWNLOAD_UMC_STICKER_PACKAGES,
    "Age Wise Stock Quantity Data - Dashboard",
    config,
    postdata
  );
}